import { Link } from "react-router-dom";

export default function Applications() {
  return (
    <div className="applications">
      <div className="apps-container">
        <h1>Application Forms</h1>
        <ul>
          <li>
            <Link
              target="_blank"
              rel="noopener"
              to="https://forms.gle/xUF2uHSDnvUtxK1k9"
            >
              Cop Applications
            </Link>
          </li>
          <li>
            <Link
              target="_blank"
              rel="noopener"
              to="https://forms.gle/J8H3A7Gu4y2mdVcW7"
            >
              EMS Applications
            </Link>
          </li>
          <li>
            <Link
              target="_blank"
              rel="noopener"
              to="https://forms.gle/yso48wZ52GXJW6nh6"
            >
              Business Applications
            </Link>
          </li>
          <li>
            <Link
              target="_blank"
              rel="noopener"
              to="https://forms.gle/qreKfZ6qRxMkV3Qm6"
            >
              Gang Boss Applications
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
